export default "__VITE_ASSET__CzjZWIir__"